<div class="alert d-flex align-items-center mt-2" [ngClass]="alertColor" *ngIf="showAlert" role="alert">
  <span class="alert-icon me-2 bg-transparent" [ngClass]="alertIconColor">
    <i class="fa-sharp fa-circle-info ti-xs"></i>
  </span>
  {{SubText}}
</div>